import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @Input() value$!: BehaviorSubject<number>;
  @Input() label: string = '';

  public progressValue: number = 0;
  public combinedText: string = '';

  private destroy$: Subject<void> = new Subject<void>();

  public ngOnInit(): void {
    if (this.value$) {
      this.value$.pipe(takeUntil(this.destroy$)).subscribe((value: number) => {
        const numericValue: number = !isNaN(value) ? value : 0;
        this.progressValue = Math.min(Math.max(numericValue, 0), 100);
        this.combinedText = `${this.label} - ${this.progressValue}%`;
      });
    } else {
      this.combinedText = `${this.label} - ${this.progressValue}%`;
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
